// import backspace from './assets/backspace.png';

function Keyboard( {onClick, onSubmit} )  {

        return (
        <div className="keyboard">
            <div className="row">
                <button 
                    className="key"
                    value="q"
                    onClick={onClick}
                >
                    Q
                </button>
                <button 
                    className="key"
                    value="w"
                    onClick={onClick}
                >
                    W
                </button>
                <button 
                    className="key"
                    value="e"
                    onClick={onClick}
                >
                    E
                </button>
                <button 
                    className="key"
                    value="r"
                    onClick={onClick}
                >
                    R
                </button>
                <button 
                    className="key"
                    value="t"
                    onClick={onClick}
                >
                    T
                </button>
                <button 
                    className="key"
                    value="y"
                    onClick={onClick}
                >
                    Y
                </button>
                <button 
                    className="key"
                    value="u"
                    onClick={onClick}
                >
                    U
                </button>
                <button 
                    className="key"
                    value="i"
                    onClick={onClick}
                >
                    I
                </button>
                <button 
                    className="key"
                    value="o"
                    onClick={onClick}
                >
                    O
                </button>
                <button 
                    className="key"
                    value="p"
                    onClick={onClick}
                >
                    P
                </button>
            </div>
            <div className="row">
                <button 
                    className="key"
                    value="a"
                    onClick={onClick}
                >
                    A
                </button>
                <button 
                    className="key"
                    value="s"
                    onClick={onClick}
                >
                    S
                </button>
                <button 
                    className="key"
                    value="d"
                    onClick={onClick}
                >
                    D
                </button>
                <button 
                    className="key"
                    value="f"
                    onClick={onClick}
                >
                    F
                </button>
                <button 
                    className="key"
                    value="g"
                    onClick={onClick}
                >
                    G
                </button>
                <button 
                    className="key"
                    value="h"
                    onClick={onClick}
                >
                    H
                </button>
                <button 
                    className="key"
                    value="j"
                    onClick={onClick}
                >
                    J
                </button>
                <button 
                    className="key"
                    value="k"
                    onClick={onClick}
                >
                    K
                </button>
                <button 
                    className="key"
                    value="l"
                    onClick={onClick}
                >
                    L
                </button>
            </div>
            <div className="row" >
                <button
                    form="row_one"
                    onSubmit={onSubmit}
                    className="bigkey"
                    type="submit" 
                >
                    ENTER
                </button>
                <button 
                    className="key"
                    value="z"
                    onClick={onClick}
                >
                    Z
                </button>
                <button 
                    className="key"
                    value="x"
                    onClick={onClick}
                >
                    X
                </button>
                <button 
                    className="key"
                    value="c"
                    onClick={onClick}
                >
                    C
                </button>
                <button 
                    className="key"
                    value="v"
                    onClick={onClick}
                >
                    V
                </button>
                <button 
                    className="key"
                    value="b"
                    onClick={onClick}
                >
                    B
                </button>
                <button 
                    className="key"
                    value="n"
                    onClick={onClick}
                >
                    N
                </button>
                <button 
                    className="key"
                    value="m"
                    onClick={onClick}
                >
                    M
                </button>
                <button 
                    className="bigkey"
                    value="delete"
                    onClick={onClick}
                >
                    DEL
                    {/* <img 
                        value="delete"
                        onClick={onClick}
                        alt="backspace icon"
                        src={backspace} /> */}
                </button>
            </div>
        </div>
    )

}

export default Keyboard;